// extracted by mini-css-extract-plugin
export var form = "download-form-module--form--Bbye3";
export var buttonArea = "download-form-module--buttonArea--3muSn";
export var buttonAreaIpo = "download-form-module--buttonAreaIpo--1o3mw";
export var buttonAreaIpoConfirm = "download-form-module--buttonAreaIpoConfirm--1qn8x";